var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-section',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.lastSyncDataLoading),expression:"lastSyncDataLoading"}],attrs:{"title":_vm.$t('Integrations_Title_Information')}},[_c('form-section',{attrs:{"title":"","description":_vm.$t('Integrations_Shopify_Text_LastSync')}},[_c('span',{staticClass:"sync-date"},[_vm._v("\n        "+_vm._s(_vm.lastSyncData !== null
            ? _vm.lastSyncDate
            : _vm.$t('Integrations_Text_NotSet'))+"\n      ")])])],1),_vm._v(" "),_c('integration-tasks-table',{attrs:{"integration-id":_vm.model.id,"task-identifiers":[
      'shopify_sync_data',
      'shopify_fetch_profile_data',
      'shopify_fetch_purchase_data'
    ]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0380007c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/integrations/types/shopify/ShopifyOverview.vue
// module id = null
// module chunks = 